<ul class="search-options"><li v-for="(option) in options" @click="setValue(option)" v-html="option"></li></ul>